import { atom } from "jotai";

import {
  currentSessionUserClientIdAtom,
  originalBookingOwnerClientIdAtom,
} from "../../stores";

export const currentUserIsBookingOwnerAtom = atom((get) => {
  const currentSessionUserClientId = get(currentSessionUserClientIdAtom);
  const originalBookingOwnerClientId = get(originalBookingOwnerClientIdAtom);
  return currentSessionUserClientId === originalBookingOwnerClientId;
});
